export default __webpack_public_path__ + "static/media/pic-2.5d5e42bf.png";